import appGlobalScript from '/Users/marc/Documents/Projekte/Coop/coop-fe-components/src/global/global.ts';
export const globalScripts = appGlobalScript;
